import { Country } from 'utils/constants'

export const ESTIMATED_VALUE_DISCLAIMER_KEY = 'estimatedValueHowToRead_anz'
export const MAP_ANZ_KEY = 'map_anz'
export const NEARMAP_KEY = 'nearmap'
export const SCHOOL_DISCLAIMER_KEY = 'school_au'
export const NEARMAP_DISCLAIMER_CONTENT = 'Aerial imagery has been sourced under agreement with Nearmap.'

export const AVM_DISCLAIMER_BY_COUNTRY = Object.freeze({
  [Country.AU]: 'avm_au',
  [Country.NZ]: 'avm_anz'
})

export const CountryDisclaimer = Object.freeze({
  AU: 'https://www.corelogic.com.au/about-us/copyright-disclaimer',
  NZ: 'https://www.corelogic.co.nz/about-us/copyright-disclaimer',
  UNKNOWN: 'UNKNOWN'
})

export const DisclaimerKeyMappingsAU = Object.freeze({
  clData_au: 'Standard Disclaimer',
  clCopyright_au: 'Copyright',
  map_anz: 'Mapping Data',
  da_au: 'Development Approval Data',
  stateNsw_au: 'State and Territory Data',
  stateSa_au: 'State and Territory Data',
  stateQLD_au: 'State and Territory Data',
  stateVic_au: 'State and Territory Data',
  stateWa_au: 'State and Territory Data',
  stateAct_au: 'State and Territory Data',
  stateTas_au: 'State and Territory Data',
  stateNt_au: 'State and Territory Data',
  service_agent: 'Service Agent Disclaimer'
})

export const DisclaimerKeyMappingsNZ = Object.freeze({
  clCopyright_nz: 'Copyright',
  clData_nz: 'Standard Disclaimer',
  map_anz: 'Mapping Data',
  building_nz: 'Building Data',
  title_nz: 'Title Data',
  service_agent: 'Service Agent Disclaimer'
})

export const LEADGEN_DISCLAIMER = [
  'publicationPpr_au',
  'clData_au',
  'publicationPpr_nz',
  'clData_nz'
]
